/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegionsControllerCreateMutationRequest, RegionsControllerCreateMutationResponse, RegionsControllerCreate400, RegionsControllerCreate401, RegionsControllerCreate403 } from "../../models/regionsController/RegionsControllerCreate";

function getRegionsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/regions` as const }  
  return res
}

/**
 * @summary Create a new region
 * {@link /api/v1/regions}
 */
export async function regionsControllerCreate(data?: RegionsControllerCreateMutationRequest, config: Partial<RequestConfig<RegionsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<RegionsControllerCreateMutationResponse, ResponseErrorConfig<RegionsControllerCreate400 | RegionsControllerCreate401 | RegionsControllerCreate403>, RegionsControllerCreateMutationRequest>({ method : "POST", url : getRegionsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}